const AUTH_TOKEN_KEY = "__ct" as const;

type AuthToken = string | null;
type AuthObserver = (token: AuthToken) => void;
type Unsubscribe = () => void;

const observers: AuthObserver[] = [];

function getToken(): AuthToken {
  if (typeof window !== "undefined" && window.localStorage) {
    return window.localStorage.getItem(AUTH_TOKEN_KEY);
  }

  return null;
}

function notify(): void {
  const token = getToken();
  observers.forEach((cb) => cb(token));
}

function signOut(): Promise<unknown> {
  return fetch("/api/auth/logout", {
    method: "GET",
  }).then((res) => {
    if (!res.ok) throw new Error("Failed to log out");
    return res.json();
  });
}

function setToken(token: string): void {
  if (typeof window !== "undefined" && window.localStorage) {
    window.localStorage.setItem(AUTH_TOKEN_KEY, token);
    notify();
  }
}

function clearToken(): void {
  setToken("");
}

function subscribe(cb: AuthObserver): Unsubscribe {
  observers.push(cb);

  return () => {
    unsubscribe(cb);
  };
}

function unsubscribe(cb: AuthObserver): void {
  const index = observers.indexOf(cb);

  if (index !== -1) {
    observers.splice(index, 1);
  }
}

const auth = {
  signOut,
  clearToken,
  setToken,
  getToken,
  subscribe,
  unsubscribe,
};

export {
  AUTH_TOKEN_KEY,
  auth,
  signOut,
  clearToken,
  setToken,
  getToken,
  subscribe,
  unsubscribe,
};

export type { AuthObserver, AuthToken, Unsubscribe };
